import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { hydrateRoot, createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import axios from "axios";
import "@/index.css";
import App from "@/App";
import "@/i18n";

// Global axios defaults — applied BEFORE any component mounts so every
// request (including the admin panel which previously didn't import
// `utils/api.js`) carries cookies. This is critical for the HTTP-only
// session_token / admin_session cookies set by the backend on login.
axios.defaults.withCredentials = true;

const rootElement = document.getElementById("root");
// StrictMode disabled in production for react-helmet-async compatibility with react-snap
// (StrictMode double-renders reset Helmet state mid-capture during pre-rendering).
const StrictWrapper = process.env.NODE_ENV === 'development' ? React.StrictMode : React.Fragment;
const appTree = (
  <StrictWrapper>
    <HelmetProvider>
      <Suspense fallback={<div className="flex items-center justify-center h-screen">Loading...</div>}>
        <App />
      </Suspense>
    </HelmetProvider>
  </StrictWrapper>
);

// react-snap pre-renders into the DOM. On initial client load we hydrate;
// for dev (CRA) and non-pre-rendered routes we fall back to createRoot.
if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, appTree);
} else {
  createRoot(rootElement).render(appTree);
}
